import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import find from "lodash/find";
import { Typography, Select, MenuItem, Tooltip } from "@mui/material";
import { useStoreFileViewerBuckets } from "../../hooks/context";
var BucketSelector = function () {
    var _a = useStoreFileViewerBuckets(), bucketId = _a.bucketId, buckets = _a.buckets, setBucketId = _a.setBucketId;
    var defaultBucketId = useMemo(function () {
        var _a;
        return (_a = find(buckets, function (bucket) { return !!bucket.default; })) === null || _a === void 0 ? void 0 : _a.id;
    }, [buckets]);
    if (!buckets.length || buckets.length === 1)
        return null;
    return (_jsx(Tooltip, { title: "Select which storage bucket to view", placement: "top", children: _jsxs(Select, { variant: "standard", size: "medium", color: "primary", sx: {
                ".MuiSelect-select": {
                    paddingTop: "8px",
                    paddingLeft: "0px",
                },
                ":before": {
                    border: "none!important",
                },
                ":after": {
                    border: "none",
                },
            }, value: bucketId || defaultBucketId || "-", onChange: function (event) {
                var value = event.target.value;
                if (value === "-") {
                    setBucketId(undefined);
                    return;
                }
                setBucketId(value);
            }, children: [!defaultBucketId && (_jsx(MenuItem, { value: "-", children: _jsx(Typography, { variant: "body2", children: "Default bucket" }) })), buckets.map(function (bucket, idx) {
                    return (_jsx(MenuItem, { value: bucket.id, children: _jsx(Typography, { variant: "body2", children: bucket.name || bucket.id }) }, "bucket-option-".concat(bucket.id, "-").concat(idx)));
                })] }) }));
};
export default BucketSelector;
